import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass({'form-label':true,'highlight':true})
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.message?.length > 0)
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.message) + " ", 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, " * ", -1)),
            _createVNode(_component_font_awesome_icon, {
              id: "fieldError",
              icon: "fa-solid fa-info-circle"
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}